import { PackageResponse, PackageGroup } from "./PackageResponse";
import { toCamelCaseObject } from "@/lib/util";

export class Package {
  /**
   * @param {Number} id
   * @param {String} name
   * @param {String} detail
   * @param {Number} billingCycle
   * @param {Number} price
   * @param {Number} originalPrice
   * @param {String} target
   * @param {String} imageUrl
   * @param {String[]} serviceIds
   * @param {PackageGroup[]} packageGroups
   */
  constructor(
    id,
    name,
    detail,
    billingCycle,
    price,
    originalPrice,
    target,
    imageUrl,
    serviceIds,
    packageGroups
  ) {
    this.id = id;
    this.name = name;
    this.detail = detail;
    this.billingCycle = billingCycle;
    this.price = price;
    this.originalPrice = originalPrice;
    this.target = target;
    this.imageUrl = imageUrl;
    this.serviceIds = serviceIds;
    this.packageGroups = packageGroups;
  }

  /**
   * @param {PackageResponse} response
   *
   * @return {Package}
   */
  static createFromResponse(response) {
    const {
      id,
      name,
      detail,
      billingCycle,
      price,
      originalPrice,
      target,
      imageUrl,
      serviceIds,
      packageGroups
    } = toCamelCaseObject(response);
    return new Package(
      id,
      name,
      detail,
      billingCycle,
      price,
      originalPrice,
      target,
      imageUrl,
      serviceIds,
      packageGroups
    );
  }
}


// WEBPACK FOOTER //
// ./src/features/subscriptions/modules/packages/models/Package.js